//
//
//
//
//
//
//
//
//
//
//

import {HotelProxy} from '@/http/RequestProxy.class';

export default {
  name: 'bcc-banner-bar',
  data(){
    return {
      bccBannerData: {},
    };
  },
  created(){
    this.getBccDiscountDetail();
  },
  methods: {
    /** 获取bcc优惠数据 */
    getBccDiscountDetail(){
      new HotelProxy().getHotelConfig()
        .then(resp => {
          if(resp){
            this.bccBannerData = resp.data.bcc;
          }
        });
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/BccBannerBar/BccBannerBar.vue